import { render, staticRenderFns } from "./ScrollLockButton.vue?vue&type=template&id=5ddf32b5&scoped=true&"
import script from "./ScrollLockButton.vue?vue&type=script&lang=ts&"
export * from "./ScrollLockButton.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollLockButton.vue?vue&type=style&index=0&id=5ddf32b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf32b5",
  null
  
)

export default component.exports